module.exports = __webpack_public_path__ + "img/planet-top-mobile.e1aeea7.webp";